(function () {
  function validateQuantityInput(input) {
    var value = Number(input.value);
    var min = Number(input.min || 1);
    var max = input.max === '' || input.max == null ? null : Number(input.max);
    var step = Number(input.step || 1);

    if (!Number.isFinite(value) || value < min) return { valid: false, message: 'Minimum ' + min };
    if (max !== null && value > max) return { valid: false, message: 'Maximum ' + max };
    if (step > 0 && (value - min) % step !== 0) return { valid: false, message: 'Buy in multiples of ' + step };
    return { valid: true, message: '' };
  }

  function normalizeQuantity(value, min, step, max) {
    min = Number(min || 1);
    step = Number(step || 1);
    max = max === '' || max == null ? null : Number(max);
    value = Number(value);

    if (!Number.isFinite(value) || value < min) value = min;
    if (step > 0) value = min + Math.ceil((value - min) / step) * step;

    if (max !== null && value > max) {
      value = min + Math.floor((max - min) / step) * step;
    }
    return value;
  }

  function getB2BInputRule(input, rule) {
    var dataRule = rule === 'min' ? input.dataset.b2bMin : input.dataset.b2bStep;
    return Number(dataRule || input[rule] || 1);
  }

  function getUnitPriceForQuantity(baseUnitPrice, serializedBreaks, quantity) {
    var activePrice = Number(baseUnitPrice);
    var activeMinimum = 0;
    String(serializedBreaks || '').split(',').forEach(function (entry) {
      var parts = entry.split(':');
      var minimum = Number(parts[0]);
      var price = Number(parts[1]);
      if (Number.isFinite(minimum) && Number.isFinite(price) && quantity >= minimum && minimum >= activeMinimum) {
        activeMinimum = minimum;
        activePrice = price;
      }
    });
    return activePrice;
  }

  function formatLineTotal(unitPrice, quantity, moneyFormat) {
    var total = Number(unitPrice) * Number(quantity);
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) return Shopify.formatMoney(total, moneyFormat);
    return '$' + (total / 100).toFixed(2);
  }

  function getCartErrorMessage(state) {
    if (state && typeof state.errors === 'string') return state.errors;
    if (state && state.errors && typeof state.errors.description === 'string') return state.errors.description;
    if (state && typeof state.description === 'string') return state.description;
    return '';
  }

  function updateLineTotal(input) {
    var total = document.getElementById(input.dataset.b2bLineTotalId);
    if (!total || input.dataset.b2bUnitPrice == null) return;
    var unitPrice = getUnitPriceForQuantity(input.dataset.b2bUnitPrice, input.dataset.b2bPriceBreaks, Number(input.value));
    var unitPriceElement = document.getElementById(input.dataset.b2bUnitPriceDisplayId);
    if (unitPriceElement) unitPriceElement.textContent = formatLineTotal(unitPrice, 1, input.dataset.b2bMoneyFormat || '${{amount}}');
    total.textContent = formatLineTotal(unitPrice, input.value, input.dataset.b2bMoneyFormat || '${{amount}}');
  }

  function normalizeInput(input) {
    var min = getB2BInputRule(input, 'min');
    var step = getB2BInputRule(input, 'step');
    input.min = min;
    input.step = step;
    var normalized = normalizeQuantity(input.value, min, step, input.max);
    if (String(normalized) !== input.value) input.value = normalized;
    updateLineTotal(input);
  }

  function validate(input) {
    var result = validateQuantityInput(input);
    var error = document.getElementById(input.dataset.b2bQuantityErrorId);
    input.setAttribute('aria-invalid', String(!result.valid));
    if (error) error.textContent = result.message;
    return result;
  }

  function bindQuantityRules(root) {
    root.querySelectorAll('[data-b2b-quantity-input]').forEach(function (input) {
      normalizeInput(input);
      if (input.dataset.b2bBound) return;
      input.dataset.b2bBound = 'true';
      input.addEventListener('input', function () { updateLineTotal(input); });
      input.addEventListener('change', function () { normalizeInput(input); validate(input); });
      input.addEventListener('blur', function () { normalizeInput(input); validate(input); });
    });
    root.querySelectorAll('[data-b2b-volume-toggle]').forEach(function (button) {
      if (button.dataset.b2bBound) return;
      button.dataset.b2bBound = 'true';
      button.addEventListener('click', function () {
        button.closest('[data-b2b-volume-pricing]').querySelectorAll('[data-b2b-volume-extra]').forEach(function (row) { row.classList.remove('hidden'); });
        button.remove();
      });
    });
  }

  if (typeof window !== 'undefined' && typeof document !== 'undefined') {
    window.AdenzoB2B = { validateQuantityInput: validateQuantityInput, normalizeQuantity: normalizeQuantity, getB2BInputRule: getB2BInputRule, getUnitPriceForQuantity: getUnitPriceForQuantity, getCartErrorMessage: getCartErrorMessage, bindQuantityRules: bindQuantityRules };
    document.addEventListener('DOMContentLoaded', function () { bindQuantityRules(document); });
    window.addEventListener('load', function () { bindQuantityRules(document); });
    window.addEventListener('pageshow', function () { bindQuantityRules(document); });
    document.addEventListener('shopify:section:load', function (event) { bindQuantityRules(event.target); });
    document.addEventListener('submit', function (event) { bindQuantityRules(event.target); }, true);
  }
  if (typeof module !== 'undefined') module.exports = { validateQuantityInput: validateQuantityInput, normalizeQuantity: normalizeQuantity, getB2BInputRule: getB2BInputRule, getUnitPriceForQuantity: getUnitPriceForQuantity, formatLineTotal: formatLineTotal, getCartErrorMessage: getCartErrorMessage };
}());
